import '@/styles/main.scss'
import { mountVueApp } from '@/app/bootstrap'

mountVueApp()
